import React, { useState } from "react";
import { ChevronRight } from "lucide-react";
import { MindmapNode } from "../../types/courseBlocks";

interface MindmapNodeViewProps {
  node: MindmapNode;
  depth: number;
}

const MindmapNodeView: React.FC<MindmapNodeViewProps> = ({ node, depth }) => {
  const hasChildren = !!node.children?.length;
  const [expanded, setExpanded] = useState(false);

  return (
    <li className="lesson-mindmap-tree__item">
      <div className="lesson-mindmap-tree__row">
        {hasChildren ? (
          <button
            type="button"
            className={`lesson-mindmap-tree__toggle ${expanded ? "is-open" : ""}`}
            onClick={() => setExpanded((prev) => !prev)}
            aria-expanded={expanded}
            aria-label={expanded ? `Collapse ${node.label}` : `Expand ${node.label}`}
          >
            <ChevronRight aria-hidden="true" size={16} />
          </button>
        ) : (
          <span className="lesson-mindmap-tree__toggle lesson-mindmap-tree__toggle--leaf" aria-hidden="true" />
        )}
        <span className="lesson-mindmap-tree__label">{node.label}</span>
      </div>

      {hasChildren && expanded && (
        <ul className="lesson-mindmap-tree__children" style={{ "--depth": depth + 1 } as React.CSSProperties}>
          {node.children!.map((child) => (
            <MindmapNodeView key={child.id} node={child} depth={depth + 1} />
          ))}
        </ul>
      )}
    </li>
  );
};

interface LessonMindmapProps {
  centralLabel: string;
  nodes: MindmapNode[];
}

const LessonMindmap: React.FC<LessonMindmapProps> = ({ centralLabel, nodes }) => {
  if (nodes.length === 0) return null;

  return (
    <figure className="lesson-mindmap-tree" role="group" aria-label={`Mind map: ${centralLabel}`}>
      <p className="lesson-mindmap-tree__central">{centralLabel}</p>
      <ul className="lesson-mindmap-tree__root">
        {nodes.map((node) => (
          <MindmapNodeView key={node.id} node={node} depth={0} />
        ))}
      </ul>
    </figure>
  );
};

export default LessonMindmap;
